import React, { FC } from 'react'

interface PlaceholderProps {
  name: string
}

export const Placeholder: FC<PlaceholderProps> = ({ name }) => (
  <p><strong>{name}</strong> has not been created yet.</p>
)
